<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <!-- <HelloWorld/> -->
    <div class="head">
      <div class="logo"></div>
      <div class="goindex el-icon-s-home " @click="gotoIndex"></div>
      <div class="head_search">
      </div>
    </div>
    <div class="indexContent">
      <index></index>
    </div>
    <div class="bottom">
      版权所有: 福建省海运集团中平船舶管理有限公司
    </div>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld'
import index from './components/index'
import * as req from '@/utils/request'

export default {
  name: 'App',
  components: {
    // HelloWorld
    index
  },
  created () {
    this.$router.push('/')
    this.getToken()
    this.getFolderList({menu_id: 200}, 'video')
  },
  data () {
    return {}
  },
  methods: {
    getFolderList (filter, folder) {
      let obj = {}
      obj.folder = folder
      obj.filter = filter
      // debugger
      let sendData = {}
      sendData.data = obj
      sendData.fn = this.getFolderListFn
      sendData.vm = this
      req.Post('fileMenuData/get_file', sendData)
    },
    getFolderListFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      // debugger
      this.global.video = data.list
    },
    // 获取url中"?"符后的字串
    getToken () {
      let url = window.location.href
      let index = url.indexOf('?')
      if (index === -1) {
        // window.location.href = this.global.loginURL
      }
      let token = url.substring(index + 1, url.length)
      token = token.replace('#/', '')
      this.global.token = token
      this.getUserData(token)
    },
    getUserData (token) {
      let msg = {}
      msg.token = token
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.getUserDatafn
      sendData.vm = this
      req.Post('user/analy_token', sendData)
    },
    getUserDatafn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.$nextTick(() => {
        this.global.user_info = data.list
      })
    },
    gotoIndex () {
      this.$confirm('退出当前用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        window.location.href = this.global.loginURL
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    }
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
}

#app {
  min-width: 1200px;
  min-height: 750px;
  width: 100%;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50; */
  /* margin-top: 60px; */
}

.goindex {
  width: 24px;
  height: 24px;
  position: absolute;
  /*left: 2%;*/
  right: 0;
  cursor: pointer;
  font-size: 22px;
}

.head {
  width: 100%;
  height: 4%;
  display: flex;
  align-items: center;
  background-color: #404040;
  color: white;
  position: relative;
  top: 0;
}

.logo {
  width: 365px;
  height: 25px;
  background-image: url(./assets/bg/02.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  -o-background-size: cover;
  margin-left: 100px;
  margin-right: 16px;
}

.indexContent {
  height: calc(96% - 42px);
}

.bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #404040;
  /*position: absolute;*/
  /*bottom: 0;*/
  height: 4.2%;
  line-height: 42px;
  position: fixed;
  bottom: 0;
  width: 100%;
  color: aliceblue;
}

.bottom2 {
  height: 6px;
}

.vjs-custom-skin > .video-js .vjs-big-play-button {
  background-color: rgba(0, 0, 0, 0.45);
  font-size: 3.5em;
  border-radius: 50%;
  height: 2em !important;
  line-height: 2em !important;
  margin-top: -1em !important;
  margin-left: -1em !important;
  width: 2em !important;
  outline: none;
  top: 27rem;
  left: 45rem;
}

.head_search {
  width: 20%;
  position: absolute;
  right: 20px;
  height: 90%;
  top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue